import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import './InfoPage.css';

// 소개 / 연락처 / 개인정보처리방침 — 애드센스 심사·방문자 신뢰용 고정 페이지 (2026-10-27)
const SITE_URL = 'https://ideademisdedos.com';
const EMAIL = 'ideademisdedos@gmail.com';
const UPDATED = '2026년 10월 27일';

const About = () => (
  <>
    <h1 className="info-title">소개 · Sobre este blog</h1>
    <p>
      <strong>Idea de mis dedos</strong>(내 손가락의 생각)는 한국어와 스페인어 사이에서 살아가며 보고,
      배우고, 느낀 것을 손끝으로 기록하는 개인 블로그입니다.
    </p>
    <h2>다루는 이야기</h2>
    <ul>
      <li><strong>¡Aprender Coreano!</strong> — 한국 드라마·예능을 소개하며 스페인어권 독자에게 한국어 표현과 문화를 알려 주는 연재입니다.</li>
      <li><strong>삶: La vida</strong> — 아르헨티나 부에노스아이레스에서 지내며 겪은 생활 정보와 일상, 짧은 글.</li>
      <li><strong>공부: Estudio</strong> — 스페인어 문법 정리와 개발 공부 기록.</li>
      <li><strong>기사: Artículo</strong> — 관심 있게 지켜보는 지역 소식과 보도자료 모음.</li>
    </ul>
    <h2>운영자</h2>
    <p>
      ssim — 한국어와 스페인어를 오가며 글을 쓰고, 이 블로그를 직접 개발·운영합니다.
      문의는 <Link to="/contact">연락처</Link> 페이지를 이용해 주세요.
    </p>
    <h2 lang="es">En español</h2>
    <p lang="es">
      Idea de mis dedos es un blog personal donde comparto la cultura y el idioma coreano a través de
      dramas y programas de TV, junto con experiencias de la vida en Buenos Aires, Argentina.
    </p>
  </>
);

const Contact = () => (
  <>
    <h1 className="info-title">연락처 · Contacto</h1>
    <p>블로그 글에 대한 의견, 오류 제보, 제휴·기타 문의는 아래 이메일로 보내 주세요.</p>
    <p className="info-contact">
      이메일: <a href={`mailto:${EMAIL}`}>{EMAIL}</a><br />
      GitHub: <a href="https://github.com/ssimdedos" target="_blank" rel="noopener noreferrer">ssimdedos</a>
    </p>
    <p>각 글 하단의 댓글로 남겨 주셔도 확인 후 답변드립니다.</p>
    <p lang="es">
      Para comentarios, correcciones o consultas, escríbeme a <a href={`mailto:${EMAIL}`}>{EMAIL}</a>.
    </p>
  </>
);

const Privacy = () => (
  <>
    <h1 className="info-title">개인정보처리방침 · Política de privacidad</h1>
    <p className="info-updated">시행일: {UPDATED}</p>
    <p>
      Idea de mis dedos(이하 "블로그")는 방문자의 개인정보를 소중히 다루며, 어떤 정보를 어떤 목적으로
      수집·이용하는지 아래와 같이 알려 드립니다.
    </p>

    <h2>1. 수집하는 정보와 목적</h2>
    <ul>
      <li><strong>방문 기록</strong> — 접속 IP 주소, 유입 경로(referrer). 방문자 수 집계와 유입 분석에만 사용합니다.</li>
      <li><strong>댓글</strong> — 닉네임, 댓글 내용, 댓글 삭제용 비밀번호(암호화하여 저장). 댓글 게시와 본인 삭제 확인에 사용합니다.</li>
      <li><strong>쿠키</strong> — 같은 방문·같은 글 조회가 중복 집계되지 않도록 방문 여부를 기억하는 쿠키를 사용합니다.</li>
    </ul>
    <p>블로그는 회원가입을 받지 않으며, 이름·연락처 등 위 항목 외의 개인정보를 수집하지 않습니다.</p>

    <h2>2. 제3자 서비스와 쿠키</h2>
    <ul>
      <li>
        <strong>Google 애드센스</strong> — 이 블로그는 광고를 게재하기 위해 Google 애드센스를 사용합니다.
        Google을 포함한 제3자 공급업체는 쿠키를 사용하여 사용자가 이 블로그나 다른 웹사이트를 이전에 방문한
        기록을 바탕으로 광고를 게재합니다. Google은 광고 쿠키를 사용하여 사용자에게 맞춤 광고를 게재할 수 있습니다.
        사용자는 <a href="https://adssettings.google.com" target="_blank" rel="noopener noreferrer">Google 광고 설정</a>에서
        맞춤 광고를 해제할 수 있습니다. 자세한 내용은{' '}
        <a href="https://policies.google.com/technologies/ads" target="_blank" rel="noopener noreferrer">Google 광고 정책</a>을 참고해 주세요.
      </li>
      <li>
        <strong>Google 애널리틱스</strong>, <strong>네이버 애널리틱스</strong> — 방문 통계를 위해 사용하며,
        각 서비스가 쿠키로 익명 이용 정보를 수집할 수 있습니다.
      </li>
    </ul>
    <p>브라우저 설정에서 쿠키 저장을 거부하거나 삭제할 수 있습니다. 이 경우 일부 기능이 제한될 수 있습니다.</p>

    <h2>3. 보관과 삭제</h2>
    <p>
      수집한 정보는 위 목적을 위해서만 보관하며, 법령에 따른 경우를 제외하고 제3자에게 제공하지 않습니다.
      댓글은 작성 시 설정한 비밀번호로 직접 삭제할 수 있고, 그 밖의 정보 열람·삭제를 원하시면
      아래 이메일로 요청해 주세요.
    </p>

    <h2>4. 문의</h2>
    <p>개인정보 관련 문의: <a href={`mailto:${EMAIL}`}>{EMAIL}</a></p>

    <h2 lang="es">Resumen en español</h2>
    <p lang="es">
      Este blog registra la dirección IP y la página de origen para estadísticas de visitas, y guarda los
      comentarios (apodo, contenido y contraseña cifrada). Usamos cookies propias y servicios de terceros
      (Google AdSense, Google Analytics y Naver Analytics). Google utiliza cookies para mostrar anuncios
      basados en visitas anteriores; puedes desactivar los anuncios personalizados en{' '}
      <a href="https://adssettings.google.com" target="_blank" rel="noopener noreferrer">Configuración de anuncios de Google</a>.
      Consultas: <a href={`mailto:${EMAIL}`}>{EMAIL}</a>.
    </p>
  </>
);

const PAGES = {
  about: { title: '소개', description: 'Idea de mis dedos 블로그와 운영자 소개', Body: About },
  contact: { title: '연락처', description: 'Idea de mis dedos 문의 및 연락처', Body: Contact },
  privacy: { title: '개인정보처리방침', description: 'Idea de mis dedos 개인정보처리방침', Body: Privacy },
};

const InfoPage = ({ page }) => {
  const { title, description, Body } = PAGES[page];

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [page]);

  return (
    <div className="info-page-container">
      <Helmet>
        <title>{title} | Idea de mis dedos</title>
        <meta name="description" content={description} />
        <link rel="canonical" href={`${SITE_URL}/${page}`} />
      </Helmet>
      <Body />
    </div>
  );
};

export default InfoPage;
